import { render, staticRenderFns } from "./ArchiveAccountsReceivable.vue?vue&type=template&id=0731c378&"
import script from "./ArchiveAccountsReceivable.vue?vue&type=script&lang=js&"
export * from "./ArchiveAccountsReceivable.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveAccountsReceivable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveAccountsReceivable.vue"
export default component.exports